import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

class StaffScheduleRequestsAdd extends Component {
  
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      start: null,
      finish: null,
      reason: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }


  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }


  loadData (event) {
    var self = this;
    var id = null;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/escala/solicitacao';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'redirect') {
          var url = '/escala/solicitacao/cadastrar/sigmec';
          self.setState({redirect_url: url});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }


  add(event) {
    event.preventDefault();
    if(window.confirm(this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.criar)) {
      this.setState({overlay: {message: '', type: '', status: 'open'}});
      var datasave = {
        start: this.state.start,
        finish: this.state.finish,
        reason: this.state.reason,
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/escala/solicitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/escala/solicitacoes';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.titulo}</h3>
      <Link to="/escala/solicitacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Inicio}:</label>
              <InputMask value={this.state.start}  maskChar={null} name="start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder="" required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Fim}:</label>
              <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder="" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>{this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Razao}:</label>
              <textarea value={this.state.reason} name="reason" className="form-control" onChange={this.handleChange.bind(this, 'reason')} placeholder="" style={{height: '200px'}} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvar}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default StaffScheduleRequestsAdd;



// WEBPACK FOOTER //
// ./src/Components/StaffScheduleRequests/StaffScheduleRequestsAdd.js